
const isRunningInNode = () => {
  return typeof window === 'undefined';
}

const excute_linux_command = async (command) => {
  const util = require('util');
  const exec = util.promisify(require('child_process').exec);
  try {
    const { stdout, stderr } = await exec(command);
    return stdout;
  } catch (error) {
    return error.stdout
  }
}

const recursiveAsyncReadLine = (callback) => {
  const readline = require('readline');
  let process2;
  if (isRunningInNode()) {
    process2 = process;
  }
  const rl = readline.createInterface({
    input: process2?.stdin,
    output: process2?.stdout
  });
  rl.question('Command: ', async function (input) {
    callback(input);
    recursiveAsyncReadLine(callback);
  })
}

module.exports = {
  excute_linux_command,
  recursiveAsyncReadLine,
  isRunningInNode
}